import { useCallback, useEffect, useState } from 'react';
import { Chip } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import { MultiDayChefitService } from '../../services/MultiDayChefitService';
import MultiChefitServeListDialog from '../Common/MultiChefitServeListDialog';

const multiDayChefitService = new MultiDayChefitService();

function MultiDayChefitAvailabilityTable(props: any) {
    const [loading, setLoading] = useState(false);
    const [availabilityData, setAvailabilityData] = useState<any[]>([]);
    const [open, setOpen] = useState<any>(null);
    const [serveListData, setServeListData] = useState<any>(null);

    const fetchData = useCallback(() => {
        const payload = {
            dateTime: props?.dateTime,
            totalPeople: props?.totalPeople,
            areaId: props?.areaId,
            serviceId: 1,
        };
        setLoading(true);
        multiDayChefitService
            .checKCookAvailabilty(props.houseId, payload)
            .then((data: any) => {
                setAvailabilityData(Array.isArray(data) ? data : []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [props]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const columns: CommonListColumn[] = [
        { label: 'Cook Id', render: (row) => row?.cookDetails?.cookId || '-' },
        {
            label: 'Cook Name',
            render: (row) => {
                const profile = row?.cookDetails?.cookFullProfile;
                return profile
                    ? `${profile.firstName} ${profile.lastName}`.trim()
                    : '-';
            },
        },
        { label: 'SLC Name', render: (row) => row?.cookDetails?.slcName || '-' },
        { label: 'Mapping Type', render: (row) => row?.cookDetails?.mappingType || '-' },
        { label: 'Availability', render: (row) => row?.availableCount ?? '-' },
        {
            label: 'See Availability',
            stopRowClick: true,
            render: (row) => (
                <Chip
                    label="See Availability"
                    color="primary"
                    onClick={() => {
                        setOpen(true);
                        setServeListData(row?.availability);
                    }}
                />
            ),
        },
    ];

    return (
        <>
            {open && (
                <MultiChefitServeListDialog
                    setOpen={setOpen}
                    serveListData={serveListData}
                    open={open}
                />
            )}
            <CommonListTable
                columns={columns}
                data={availabilityData}
                loading={loading}
                emptyText="No Cook Available"
            />
        </>
    );
}

export default MultiDayChefitAvailabilityTable;
